import React from 'react';
import { BRAND, isMarketGB } from '../../../constants/main';
import { BasketCashPaymentSelectionAC } from './AC/BasketCashPaymentSelection.AC';
import { BasketCashPaymentSelectionOV } from './OV/BasketCashPaymentSelection.OV';
import { BasketCashPaymentSelectionAP } from './AP/BasketCashPaymentSelection.AP';
import { BasketCashPaymentSelectionDS } from './DS/BasketCashPaymentSelection.DS';
import { BasketCashPaymentSelectionOV as BasketCashPaymentSelectionOV_GB } from './OV/GB/BasketCashPaymentSelection.OV';
import { BasketSelectSectionStyled } from './BasketCashPaymentSelectionStyled';
import { SC } from '../../../styles/theme';

export type BasketCashPaymentSelectionProps = SC & {
    onClick: (value: string) => void;
    isSelected: boolean;
};

const BasketCashPaymentSelection = (props: BasketCashPaymentSelectionProps) => {
    if (BRAND === 'AC') return <BasketCashPaymentSelectionAC {...props} />;
    if (BRAND === 'OV')
        return isMarketGB ? (
            <BasketCashPaymentSelectionOV_GB {...props} />
        ) : (
            <BasketCashPaymentSelectionOV {...props} />
        );
    if (BRAND === 'AP') return <BasketCashPaymentSelectionAP {...props} />;
    if (BRAND === 'DS') return <BasketCashPaymentSelectionDS {...props} />;
    return <BasketSelectSectionStyled {...props} />;
};

export default BasketCashPaymentSelection;
